import { render, staticRenderFns } from "./cta-box-cmp.vue?vue&type=template&id=7d090886&scoped=true"
import script from "./cta-box-cmp.vue?vue&type=script&lang=js"
export * from "./cta-box-cmp.vue?vue&type=script&lang=js"
import style0 from "./cta-box-cmp.vue?vue&type=style&index=0&id=7d090886&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d090886",
  null
  
)

export default component.exports